var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-wrapper" },
    [
      _c("div", { staticClass: "border-top" }),
      _c("div", { staticClass: "border-left" }),
      _c("div", { staticClass: "border-bottom" }),
      _c("div", { staticClass: "border-right" }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }